module.exports = __webpack_public_path__ + "static/en-f085ca53ba13d3395d6ebbb101b5e072.svg";